
import { func } from "@/main";
import axios from "axios"


const state = {
    DocPinList: [],
    UpdateDocPinList:true
};


const getters = {
    GetDocPinList(state: any) {
        return state.DocPinList;
    },
    GetUpdateDocPinList(state:any){
        return state.UpdateDocPinList;
    }
};

const mutations = {

    SetDocPinList(state: any, list: any) {
        state.DocPinList = list;
    },
    SetUpdateDocPinList(state:any,val:any){
        state.UpdateDocPinList=val;
    }

};

const actions = {
    GetDocPinListFromServer(context: any) {
        axios.get("DocPin/GetDocPinList")
            .then(data => {
                context.commit("SetDocPinList", data.data);
            });
    },
    AddPin(context: any, filter: any) {
        axios.get("DocPin/AddPin", {
            params: {
                baseDocId: filter.baseDocId,
                docId: filter.docId,
                description: filter.description
            }
        })
            .then(data => {
                if(data.data=="1")
                {
                    func.showSuccessMessage("به لیست نشان شده ها افزوده شد.");
                    context.commit("SetUpdateDocPinList", true);
                }
                else{
                    console.log(data.data);
                }
                
            });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
